import find from 'lodash/find';

export const getBy = (field, value, objects) => find(objects, {[field]: value}) || null;

export const getById = (id, objects) => getBy('id', id, objects);

export const getByValue = (value, objects) => getBy('value', value, objects);
